import {createApp} from 'vue'

// Vuetify
import 'vuetify/styles'
import {createVuetify} from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import {createPinia} from 'pinia'
import {Vue3Toastify} from 'vue3-toastify'
import {vueKeycloak} from '@josempgon/vue-keycloak'
import 'vue3-toastify/dist/index.css'


// Components
import App from './App.vue'

const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'light',
    },
})

const pinia = createPinia()
const domain = window.location.hostname.replace(/^www\./, '').split('.')[0];


const app = createApp(App)
    .use(vuetify)
    .use(pinia)
    .use(Vue3Toastify)
    .use(vueKeycloak, {
        config: {
            url: 'https://' + domain + "-auth/auth", // Production Keycloak URL
            //url: 'https://metrocairo-auth.magentalab.it/auth', // Production Keycloak URL
            // url: 'http://localhost:8091/auth', // Use this for local testing with a local instance of Keycloak
            realm: 'cairo-metro4',
            clientId: 'cairo-metro4-app'
        },
        initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false
        }
    })

const keycloak = app.config.globalProperties.$keycloak
export {keycloak}

app.mount('#app')
